import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {PinIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import type {SubscribedEventNode} from './issue-viewer-view-query-types'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(SubscribedEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when the timeline pagination fragments leave Relay.
export type SubscribedEventFragment = RelayCompat<Pick<SubscribedEventNode, 'actor' | 'createdAt' | 'databaseId'>>

type SubscribedEventProps = {
  queryRef: SubscribedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function SubscribedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: SubscribedEventProps): React.ReactElement {
  const {actor, createdAt, databaseId} = queryRef
  const highlighted = String(databaseId) === highlightedEventId

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={issueUrl}
      onLinkClick={onLinkClick}
      leadingIcon={PinIcon}
    >
      <TimelineRow.Main>{`${LABELS.timeline.subscribed} `}</TimelineRow.Main>
    </TimelineRow>
  )
}
